import React, { FC } from 'react';
import moment from 'moment';
import { BetterMoment, Image } from 'components/molecules';
import styles from './style.module.scss';

export type ImagePreviewPhoto = {
  url: string;
  timestamp?: string;
};

type ImagePreviewsProps = {
  photos?: ImagePreviewPhoto[];
  title?: string;
};

export const ImagePreviews: FC<ImagePreviewsProps> = ({ photos, title }) => {

  if (!photos?.length) return null;

  const sortedPhotos = [...photos].sort((a, b) => {

    if (!a.timestamp || !b.timestamp) return 0;

    return moment(a.timestamp).valueOf() - moment(b.timestamp).valueOf();

  });

  return (
    <div className={styles.imagePreviews}>
      {title && (
        <div className={styles.title}>
          {title}
        </div>
      )}
      <div className={styles.grid}>
        {sortedPhotos.map((photo, index) => (
          <div key={index} className={styles.imagePreview}>
            <Image
              className={styles.image}
              src={photo.url}
              alt={photo.timestamp ?? photo.url}
            />
            {photo.timestamp && (
              <BetterMoment
                className={styles.time}
                format={'HH:mm:ss'}
              >
                {moment(photo.timestamp)}
              </BetterMoment>
            )}
          </div>
        ))}
      </div>
    </div>
  );

};
